import { summarizeAwsCron } from "utils/awsCron";
import type { PendingValue, PendingValueKind } from "./PendingChangesContext";

type Json = Record<string, unknown>;

/** Structural equality for pending-change values (configs are plain JSON). */
export function deepEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (typeof a !== "object" || typeof b !== "object" || a == null || b == null)
    return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;
  if (Array.isArray(a)) {
    return (
      a.length === (b as unknown[]).length &&
      a.every((v, i) => deepEqual(v, (b as unknown[])[i]))
    );
  }
  const keysA = Object.keys(a as Json);
  const keysB = Object.keys(b as Json);
  return (
    keysA.length === keysB.length &&
    keysA.every(
      (k) =>
        Object.prototype.hasOwnProperty.call(b, k) &&
        deepEqual((a as Json)[k], (b as Json)[k]),
    )
  );
}

/**
 * Display string for a scalar pending value; the review dialog renders it
 * inside a value chip (so no quoting). ``config`` records never come here -
 * they go through the structural diff (configDiff + DiffView).
 */
export function formatPendingValue(
  kind: PendingValueKind,
  value: PendingValue,
): string {
  switch (kind) {
    case "enabled":
      return value ? "Enabled" : "Disabled";
    case "active":
      return value ? "Active" : "Inactive";
    case "cron":
      return summarizeAwsCron(String(value));
    default:
      return String(value);
  }
}
